"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventEmitter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nodeEvents = require("node:events");
var isBrowser = typeof window !== 'undefined';
var isEventTarget = function(manager) {
    return manager instanceof EventTarget;
};
/**
 * Event dispatcher for both browser and server
 */ var EventEmitter = /*#__PURE__*/ function() {
    function EventEmitter() {
        _class_call_check(this, EventEmitter);
        (0, _defineProperty2.default)(this, "manager", void 0);
        /**
     * This mapper serves as a helper to match the bevior of event emmiters on server to client
     */ (0, _defineProperty2.default)(this, "listenerToBrowserEventListeners", new Map());
        this.manager = isBrowser ? new EventTarget() : new _nodeEvents.EventEmitter();
    }
    _create_class(EventEmitter, [
        {
            /**
   * Adds listener to instance
   */ key: "addListener",
            value: function addListener(eventName, listener) {
                if (isEventTarget(this.manager)) {
                    var customEventListener = function(event) {
                        listener(event.detail);
                    };
                    var eventListener = customEventListener;
                    this.listenerToBrowserEventListeners.set(listener, eventListener);
                    this.manager.addEventListener(eventName, eventListener);
                } else {
                    // We need to override type this way
                    this.manager.addListener(eventName, listener);
                }
            }
        },
        {
            /**
   * Removes listener from disaptcher instance
   */ key: "removeListener",
            value: function removeListener(eventName, listenerReference) {
                if (isEventTarget(this.manager)) {
                    var eventListenerUnderReference = this.listenerToBrowserEventListeners.get(listenerReference);
                    if (eventListenerUnderReference) {
                        this.manager.removeEventListener(eventName, eventListenerUnderReference);
                    }
                } else {
                    this.manager.removeListener(eventName, listenerReference);
                }
            }
        },
        {
            /**
   * Emit event on dispatcher instance
   */ key: "emit",
            value: function emit(eventName, data) {
                if (isEventTarget(this.manager)) {
                    this.manager.dispatchEvent(new CustomEvent(eventName, {
                        detail: data
                    }));
                } else {
                    this.manager.emit(eventName, data);
                }
            }
        }
    ]);
    return EventEmitter;
}();
exports.EventEmitter = EventEmitter; //# sourceMappingURL=EventEmitter.js.map
